import React, { useEffect, useState } from "react";
import {
  Table,
  Button,
  Modal,
  Form,
  Input,
  Select,
  message,
  Space,
  Layout,
} from "antd";
import axiosInstance from "../api/axiosInstance";
import Sidebar from "../components/Sidebar";
import AppHeader from "../components/Header";
import { Content } from "antd/es/layout/layout";

const UsersList = () => {
  const [users, setUsers] = useState([]);
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    fetchUsers();
    fetchRoles();
  }, []);

  const fetchUsers = async () => {
    setLoading(true);
    try {
      const res = await axiosInstance.get("/referensi/user");
      setUsers(res.data);
    } catch (error) {
      message.error("Gagal mengambil data user");
    }
    setLoading(false);
  };

  const fetchRoles = async () => {
    try {
      const res = await axiosInstance.get("/referensi/role");
      setRoles(res.data);
    } catch (error) {
      message.error("Gagal mengambil data role");
    }
  };

  const handleAddOrUpdate = async (values) => {
    try {
      if (currentUser) {
        await axiosInstance.put(
          `/referensi/user/${currentUser.id_user}`,
          values
        );
        message.success("User berhasil diperbarui");
      } else {
        await axiosInstance.post("/referensi/user", values);
        message.success("User berhasil ditambahkan");
      }
      fetchUsers();
      setIsModalVisible(false);
      setCurrentUser(null);
    } catch (error) {
      message.error("Gagal menyimpan user");
    }
  };

  const handleDelete = async (id) => {
    try {
      await axiosInstance.delete(`/referensi/user/${id}`);
      message.success("User berhasil dihapus");
      fetchUsers();
    } catch (error) {
      message.error("Gagal menghapus user");
    }
  };

  const columns = [
    { title: "Nama User", dataIndex: "nama_user", key: "nama_user" },
    { title: "Jabatan", dataIndex: "jabatan_user", key: "jabatan_user" },
    {
      title: "Role",
      dataIndex: "id_role",
      key: "id_role",
      render: (id_role) =>
        roles.find((role) => role.id_role === id_role)?.nama_role || "N/A",
    },
    {
      title: "Aksi",
      render: (text, record) => (
        <Space>
          <Button
            type="primary"
            onClick={() => {
              setCurrentUser(record);
              setIsModalVisible(true);
            }}
          >
            Edit
          </Button>
          <Button type="danger" onClick={() => handleDelete(record.id_user)}>
            Hapus
          </Button>
        </Space>
      ),
    },
  ];

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar />
      <Layout style={{ marginLeft: 260 }}>
        {/* Menyesuaikan lebar sidebar */}
        <AppHeader />
        <Content
          style={{
            margin: "20px",
            padding: "20px",
            background: "#fff",
            minHeight: "100vh",
          }}
        >
          <h2 style={{ marginBottom: "20px" }}>Daftar User</h2>
          <div>
            <Button
              type="primary"
              onClick={() => {
                setCurrentUser(null);
                setIsModalVisible(true);
              }}
            >
              Tambah User
            </Button>
            <Table
              columns={columns}
              dataSource={users}
              loading={loading}
              rowKey="id_user"
            />

            <Modal
              title={currentUser ? "Edit User" : "Tambah User"}
              visible={isModalVisible}
              onCancel={() => setIsModalVisible(false)}
              footer={null}
            >
              <Form
                initialValues={currentUser}
                onFinish={handleAddOrUpdate}
                layout="vertical"
              >
                <Form.Item
                  label="Nama User"
                  name="nama_user"
                  rules={[{ required: true }]}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  label="Password"
                  name="password"
                  rules={[{ required: !currentUser }]}
                >
                  <Input.Password />
                </Form.Item>
                <Form.Item label="Jabatan" name="jabatan_user">
                  <Input />
                </Form.Item>
                <Form.Item
                  label="Role"
                  name="id_role"
                  rules={[{ required: true }]}
                >
                  <Select>
                    {roles.map((role) => (
                      <Select.Option key={role.id_role} value={role.id_role}>
                        {role.nama_role}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
                <Button type="primary" htmlType="submit">
                  Simpan
                </Button>
              </Form>
            </Modal>
          </div>
        </Content>
      </Layout>
    </Layout>
  );
};

export default UsersList;
